import React from "react";
import { ResponsiveBar } from "@nivo/bar";

import styles from "./BarPercentChart.module.css";
import Legend from "../legend/Legend";

const BarPercentChart = ({
  data,
  height,
  width,
  topLineFromTop,
  bottomLineFromBottom,
  percentTicksAtBottom,
  displayTickLabels,
  maxTickLabelLength,
  legend,
}) => {
  // for displaying 0% 25% 50% 75% 100% at top or bottom
  const axisTopOrBottomProps = {
    tickSize: 0,
    tickPadding: 5,
    tickRotation: 0,
    tickValues: [0, 25, 50, 75, 100],
    format: (value) => value + "%",
    renderTick: (tick) => (
      <g
        transform={`translate(${tick.x + 2},${
          tick.y + percentTicksAtBottom ? 12 : -15
        })`}
      >
        <text
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#748AA1"
          fontWeight={600}
          style={{ fontSize: 12, color: "#748AA1" }}
        >
          {tick.value}%
        </text>
      </g>
    ),
  };

  const truncateTickLabel = (label) => {
    if (!maxTickLabelLength || label.length <= maxTickLabelLength) {
      return label;
    }

    return `${label.slice(0, maxTickLabelLength).trimEnd()}...`;
  };

  const maxLetterCount = Math.max(
    ...data.map((item) =>
      maxTickLabelLength
        ? Math.min(item.id.length, maxTickLabelLength + 3)
        : item.id.length
    )
  ) - 50;

  return (
    <div className={styles.barPercentChartTopContainer}>
      <div
        style={{ height, width }}
        className={styles.barPercentChartContainer}
      >
        <span
          className={styles.topCoverLine}
          style={{ top: topLineFromTop }}
        ></span>
        <ResponsiveBar
          data={data}
          keys={["percent"]}
          margin={{
            top: percentTicksAtBottom ? 0 : 25,
            right: 36,
            bottom: 16,
            left: 10 + (displayTickLabels ? maxLetterCount * 6 : 0),
          }}
          padding={0.75}
          barComponent={CustomBarComponent}
          layout="horizontal"
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true }}
          colors={{ datum: "data.color" }}
          borderColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          maxValue={100}
          axisTop={!percentTicksAtBottom ? axisTopOrBottomProps : null}
          axisRight={null}
          axisBottom={percentTicksAtBottom ? axisTopOrBottomProps : null}
          axisLeft={{
            tickSize: 0,
            // tickPadding: 5,
            // tickRotation: 0,
            ...(maxTickLabelLength && {
              renderTick: (tick) => (
                <g transform={`translate(${tick.x},${tick.y})`}>
                  <title>{tick.value}</title>
                  <text
                    x={-5}
                    y={0}
                    textAnchor="end"
                    dominantBaseline="middle"
                    fill="#333"
                    style={{ fontSize: 11 }}
                  >
                    {truncateTickLabel(tick.value)}
                  </text>
                </g>
              ),
            }),
            ...(!displayTickLabels && {
              format: () => null,
              renderTick: () => null,
            }),
          }}
          enableGridX={true}
          gridXValues={[0, 25, 50, 75, 100]}
          enableGridY={false}
          enableLabel={false}
          animate={true}
        />
        <span
          className={styles.bottomCoverLine}
          style={{ bottom: bottomLineFromBottom }}
        ></span>
      </div>
      {legend && <Legend direction="column" data={data} />}
    </div>
  );
};

const CustomBarComponent = (props) => {
  const { bar } = props;
  const { x, y, width, height, color, data } = bar;
  const percent = data?.data?.percent ?? 0;

  return (
    <>
      <rect
        x={x - 4}
        y={y}
        width={width + 4}
        height={height}
        rx={5}
        fill={color}
      />
      <text
        x={x + width + 20}
        y={y + height - 3}
        fill="black"
        dominantBaseline="middle"
        textAnchor="middle"
        fontWeight={500}
        style={{ fontSize: 13 }}
      >
        {`${percent} %`}
      </text>
    </>
  );
};
export default BarPercentChart;
